import { remove } from '../../../../../../utils'

export const clearExportData = (values) => remove(values, ['exportData'])

export const validateJumpLink = (jumpLink) => jumpLink && jumpLink.match(/(#[\w-]+$)/)

export const validateLocation = (location) => {
  let errors = {}

  if (!location || !location.type) {
    errors || (errors = {})
    errors.type = 'Type is required'
  }

  if (location.type === 'URL' && !location.url && !location.ctaRelativeUrl) {
    errors || (errors = {})
    errors.url = 'URL is required'
  }

  if (location.type === 'Page' && !location.pageId) {
    errors || (errors = {})
    errors.pageId = 'Page is required'
  }

  if (location.type === 'Page' && location.pageSectionId && !validateJumpLink(location.pageSectionId)) {
    errors || (errors = {})
    errors.pageSectionId = 'Invalid jump link'
  }

  if (location.type === 'Jump Link' && !validateJumpLink(location.jumpLink)) {
    errors || (errors = {})
    errors.jumpLink = 'Invalid jump link'
  }

  return Object.keys(errors).length == 0 ? null : errors
}
